import React from 'react'
import classNames from 'classnames'
import { Divider } from 'antd'

import styles from './styles.module.scss'

import type { LntDividerProps } from './types'

export const LntDivider: React.FC<LntDividerProps> = ({
  removeMargins,
  className: outerClassname,
  children,
  ...restProps
}) => {
  const className = classNames(
    {
      [styles.lntDivider_removeMargins]: removeMargins
    },
    outerClassname
  )

  return (
    <Divider
      { ...restProps }
      className={ className }
    >
      { children }
    </Divider>
  )
}
